import ProjectList from "../../widgets/projectList/ui/projectList";

function RootPage() {
    return (
    <>
        <ProjectList />
    </>
    )
}

export default RootPage;